const nav_bar = {
	console: "Console",
	overview: "Overzicht",
	snapshots: "Snapshots",
	ssh_keys: "SSH-keys",
};

export default nav_bar;
